"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createEphemeralSessionStorage = createEphemeralSessionStorage;
var tsafe_1 = require("../vendor/frontend/tsafe");
var SessionStorageItem_Parsed;
(function (SessionStorageItem_Parsed) {
    SessionStorageItem_Parsed.brand = "SessionStorageItem_Parsed";
})(SessionStorageItem_Parsed || (SessionStorageItem_Parsed = {}));
function parseSessionStorageItem(sessionStorageItemValue) {
    var json;
    try {
        json = JSON.parse(sessionStorageItemValue);
    }
    catch (_a) {
        return undefined;
    }
    if (!(0, tsafe_1.typeGuard)(json, json instanceof Object &&
        "__brand" in json &&
        json.__brand === SessionStorageItem_Parsed.brand)) {
        return undefined;
    }
    return json;
}
var SESSION_STORAGE_PREFIX = "ephemeral:";
function createStoreInSessionStorageAndScheduleRemovalInMemoryItem(params) {
    var key = params.key, value = params.value, remainingTtlMs = params.remainingTtlMs;
    var sessionStorageKey = "".concat(SESSION_STORAGE_PREFIX).concat(key);
    var removeFromSessionStorage = function () {
        inMemoryItem.removeFromSessionStorage = undefined;
        clearTimeout(timer);
        sessionStorage.removeItem(sessionStorageKey);
    };
    var timer = setTimeout(function () { return removeFromSessionStorage(); }, remainingTtlMs);
    var inMemoryItem = {
        key: key,
        value: value,
        removeFromSessionStorage: removeFromSessionStorage
    };
    sessionStorage.removeItem(sessionStorageKey);
    sessionStorage.setItem(sessionStorageKey, JSON.stringify((0, tsafe_1.id)({
        __brand: "SessionStorageItem_Parsed",
        value: value,
        expiresAtTime: Date.now() + remainingTtlMs
    })));
    return inMemoryItem;
}
function createEphemeralSessionStorage(params) {
    var sessionStorageTtlMs = params.sessionStorageTtlMs;
    var inMemoryItems = [];
    for (var i = 0; i < sessionStorage.length; i++) {
        var sessionStorageKey = sessionStorage.key(i);
        (0, tsafe_1.assert)(sessionStorageKey !== null);
        if (!sessionStorageKey.startsWith(SESSION_STORAGE_PREFIX)) {
            continue;
        }
        var sessionStorageItem = sessionStorage.getItem(sessionStorageKey);
        (0, tsafe_1.assert)(sessionStorageItem !== null);
        var sessionStorageItem_parsed = parseSessionStorageItem(sessionStorageItem);
        if (sessionStorageItem_parsed === undefined) {
            continue;
        }
        var remainingTtlMs = sessionStorageItem_parsed.expiresAtTime - Date.now();
        if (remainingTtlMs <= 0) {
            sessionStorage.removeItem(sessionStorageKey);
            continue;
        }
        inMemoryItems.push(createStoreInSessionStorageAndScheduleRemovalInMemoryItem({
            key: sessionStorageKey.slice(SESSION_STORAGE_PREFIX.length),
            value: sessionStorageItem_parsed.value,
            remainingTtlMs: remainingTtlMs
        }));
    }
    var storage = {
        get length() {
            return inMemoryItems.length;
        },
        key: function (index) {
            var inMemoryItem = inMemoryItems[index];
            if (inMemoryItem === undefined) {
                return null;
            }
            return inMemoryItem.key;
        },
        removeItem: function (key) {
            var _a;
            var inMemoryItem = inMemoryItems.find(function (item) { return item.key === key; });
            if (inMemoryItem === undefined) {
                return;
            }
            (_a = inMemoryItem.removeFromSessionStorage) === null || _a === void 0 ? void 0 : _a.call(inMemoryItem);
            var index = inMemoryItems.indexOf(inMemoryItem);
            inMemoryItems.splice(index, 1);
        },
        clear: function () {
            for (var i = 0; i < storage.length; i++) {
                var key = storage.key(i);
                (0, tsafe_1.assert)(key !== null);
                storage.removeItem(key);
            }
        },
        getItem: function (key) {
            var inMemoryItem = inMemoryItems.find(function (item) { return item.key === key; });
            if (inMemoryItem === undefined) {
                return null;
            }
            return inMemoryItem.value;
        },
        setItem: function (key, value) {
            var _a;
            var existingInMemoryItemIndex = undefined;
            {
                var inMemoryItem = inMemoryItems.find(function (item) { return item.key === key; });
                if (inMemoryItem !== undefined) {
                    (_a = inMemoryItem.removeFromSessionStorage) === null || _a === void 0 ? void 0 : _a.call(inMemoryItem);
                    existingInMemoryItemIndex = inMemoryItems.indexOf(inMemoryItem);
                }
            }
            var inMemoryItem_new = createStoreInSessionStorageAndScheduleRemovalInMemoryItem({
                key: key,
                value: value,
                remainingTtlMs: sessionStorageTtlMs
            });
            if (existingInMemoryItemIndex !== undefined) {
                inMemoryItems[existingInMemoryItemIndex] = inMemoryItem_new;
            }
            else {
                inMemoryItems.push(inMemoryItem_new);
            }
        }
    };
    return storage;
}
//# sourceMappingURL=ephemeralSessionStorage.js.map